import React from 'react'
import validator from 'validator'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { firebaseConnect } from 'react-redux-firebase'
import { reduxForm, Field, SubmissionError } from 'redux-form'

import * as UI from '../components'
import * as commands from '../commands'
import * as constants from '../constants'
import { userIsAuthenticated } from '../behaviors'

class IdentityValidation extends React.Component {
  render() {
    const {
      handleSubmit,
      updateProfile,
      error,
      submitting,
      submitSucceeded,
      submitFailed,
      pristine,
      profile,
      storefront,
      invalid,
    } = this.props

    if (profile && profile.identityValidationStatus) {
      if (profile.identityValidationStatus === 'submitted') {
        return (
          <UI.Card>
            <UI.Text center uppercase size="huge" color="accent">
              Your information has been submitted successfully
            </UI.Text>
            <UI.Divider hidden />
            <UI.Text>
              We will let you know if we need more info - thanks for your
              support!
            </UI.Text>
            <UI.Divider hidden />
            <UI.Text center>
              <UI.Button to="/">Purchase {storefront.tokenName}</UI.Button>
            </UI.Text>
          </UI.Card>
        )
      }

      if (profile.identityValidationStatus === 'approved') {
        return (
          <UI.Card>
            <UI.Text center uppercase size="huge" color="accent">
              Your information has been verified successfully
            </UI.Text>
            <UI.Divider hidden />
            <UI.Text>Thanks for your support!</UI.Text>
            <UI.Divider hidden />
            <UI.Text center>
              <UI.Button to="/">Purchase {storefront.tokenName}</UI.Button>
            </UI.Text>
          </UI.Card>
        )
      }

      if (profile.identityValidationStatus === 'manual') {

        if (storefront.storefrontId === '-KyWMfkc2qAP69d7q6E4') {
          return <MADCard storefront={storefront} />
        } else {
          return <ManualApproval storefront={storefront} />
        }
      }
    }

    return (
      <UI.Form size="large" onSubmit={handleSubmit(updateProfile)}>
        <UI.Card loading={submitting}>
          <UI.Text uppercase color="accent">
            Identity Verification
          </UI.Text>

          <UI.Divider />

          {submitFailed && <UI.Message type="error">{error}</UI.Message>}
          {submitSucceeded && (
            <UI.Message type="success">
              Your profile has been updated
            </UI.Message>
          )}

          <UI.Divider hidden />

          <Field
            fluid
            label="First Name"
            name="firstName"
            component={UI.TextField}
          />
          <Field
            fluid
            label="Last Name"
            name="lastName"
            component={UI.TextField}
          />
          <Field
            fluid
            label="Phone Number"
            placeholder="+1 (xxx) xxx-xxxx"
            name="phoneNumber"
            component={UI.TextField}
          />
          <Field fluid label="City" name="city" component={UI.TextField} />
          <Field
            fluid
            label="Country"
            search
            name="country"
            component={UI.SelectField}
            options={constants.countryCodes}
          />
          <Field
            fluid
            label="Date of Birth"
            hint="YYYY-MM-DD"
            name="dob"
            component={UI.TextField}
          />

          <UI.Divider hidden />

          <UI.Button disabled={pristine || invalid || submitting}>
            Save
          </UI.Button>
        </UI.Card>
      </UI.Form>
    )
  }
}

const MADCard = (props) => {
  const { storefront } = props
  return <UI.Card>
    <UI.Text center uppercase size='huge' color="accent">We need more information</UI.Text>
    <UI.Divider hidden />
    <UI.Text>
      We are unable to grant you instant access to our sale. Please contact <a href={ 'mailto:'+ storefront.contactEmail }>{storefront.contactEmail}</a> for support.
    </UI.Text>
    <UI.Divider />
    <UI.Text size='huge' color='accent'>Notes:</UI.Text>
    <UI.Text size='huge'><UI.Text weight='bold' size='huge'>In the United States:</UI.Text> Participation is available only to accredited investors</UI.Text>
    <UI.Text center><UI.Link to='https://www.earlyiq.com/partner/mad/investor/one/getstarted' target='_blank'> Verify Accredition Status with Early IQ</UI.Link></UI.Text>
    <UI.Divider hidden />
    <UI.Text size='huge'><UI.Text weight='bold' size='huge'>In Singapore:</UI.Text> Participation is not available</UI.Text>
    <UI.Divider hidden />
    <UI.Button to='/'>&larr; Back</UI.Button>
  </UI.Card>
}

const ManualApproval = (props) => {
  const { storefront } = props
  return <UI.Card>
    <UI.Text center uppercase size='huge' color="accent">We need more information</UI.Text>
    <UI.Divider hidden />
    <UI.Text>
      We are unable to grant you instant access to our sale. This could be for a number of factors, including geography or VPN use.
    </UI.Text>
    <UI.Divider hidden />
    <UI.Text size='huge'>
      Please contact <a href={ 'mailto:'+ storefront.contactEmail }>{storefront.contactEmail}</a> for help getting this resolved.
    </UI.Text>
  </UI.Card>
}


const selectors = createStructuredSelector({
  initialValues: ({ firebase: { profile } }) => {
    return {
      firstName: '',
      lastName: '',
      dob: '',
      city: '',
      country: '',
      phoneNumber: '',
      augurDfp: JSON.parse(sessionStorage.getItem('augurDfp')),
      ...profile && profile.isLoaded && profile.identity
        ? profile.identity
        : {},

    }
  },
  profile: ({ firebase }) => firebase.profile,
})

const actions = (dispatch, props) => ({
  updateProfile: async identity => {
    try {
      await props.firebase.updateProfile({ identity: identity })
      const authToken = await props.firebase.auth().currentUser.getIdToken(true)
      dispatch({
        type: 'IDENTITY_VERIFICATION_SUBMITTED',
        track: {},
      })

      const { command } = await commands.validateIdentity(authToken, identity)
      return command
    } catch (error) {
      throw new SubmissionError({ _error: error.message })
    }
  },
})

const validate = values => {
  const errors = {}

  if (validator.isEmpty(values.firstName))
    errors.firstName = 'First name is required'
  if (validator.isEmpty(values.lastName))
    errors.lastName = 'Last name is required'
  if (validator.isEmpty(values.dob)) errors.dob = 'Date of Birth is required'

  return errors
}

export default compose(
  firebaseConnect(),
  connect(selectors, actions),
  reduxForm({ form: 'IdentityValidation', validate, enableReinitialize: true }),
  userIsAuthenticated()
)(IdentityValidation)



// WEBPACK FOOTER //
// ./src/screens/IdentityValidation.js